import { createPost } from '@eshop/api-client'

import { Config } from '#/global/helper/Config'

type Engines = `products-${'eshop' | 'rental'}` | 'articles' | `nodes-${'eshop' | 'rental'}` | 'manufacturer'

export const sendReport = async (query: string, engine: Engines, itemId: string, href: string) => {
    const post = createPost('search')

    const searchParameters = new URLSearchParams({
        autocomplete: 'false',
        query,
        item_id: itemId,
    })

    try {
        await post(`/v2/${Config.getSearchCompany()}/${engine}/item-clicked?${searchParameters.toString()}`)
    } finally {
        location.href = href
    }
}
